import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take, timeInterval } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';
import { AdditionalContact } from '../additional-contact/additional-contact';
import {DependentDetails} from '../../dependent-and-family/dependent-details/dependent-details';
import { EmploymentDetails } from '../../employment-and-incomedetails/employment-details/employment_details';
import { IncomeDetails } from '../../employment-and-incomedetails/income-details/income_details';
import {AddressDetail} from '../address-detail/address-detail';
import {ADFFormService} from '../../../services/adf-form.service';

declare var google;
@Component({
  selector: 'adfprimaryform',
  templateUrl: 'primary.html',
  providers: [EnvDataService]
})
export class PrimaryForm {
  @Input() editdata: any;
  @ViewChild(AdditionalContact) AdditionalContact: AdditionalContact;
  @ViewChild(DependentDetails) DependentDetail: DependentDetails;
  @ViewChild(EmploymentDetails) EmploymentDetails: EmploymentDetails;
  @ViewChild(IncomeDetails) IncomeDetails: IncomeDetails;
  @ViewChild(AddressDetail) AddressDetail:AddressDetail;
  @Output() valueChange = new EventEmitter();
  @Output() UserAndBrokerId=new EventEmitter();
  @Output() sendEmployemntDetailsData=new EventEmitter();
  @Output() primaryformData_evntemit = new EventEmitter();
  @Output() deleteApplicant_evntemit = new EventEmitter();
  user_email:string;

  callMethod() {


  }

  primaryForm: FormGroup;
  additionalForm:FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public address_format;
  public indexx : number;
  @Output() userdata_evntemit=new EventEmitter();
  @Output() anotherApplicant_evntemit=new EventEmitter();
  @Output() userdataAddi_evntemit = new EventEmitter();
  anotherApplicantEmail:string;
  alldataForEdit:any;
  modeOfOperation:any;
  hidetoggle=[];

  public validation_messages = {
    'firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'reference_broker': [
      { type: 'required', message: 'Broker is required.' }
    ],
    'title': [
      { type: 'required', message: 'Application Title is required.' }
    ],
    'secondary_firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'secondary_lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'secondary_email': [
          { type: 'required', message: 'Email is required.' }
        ],
    'secondary_mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'secondary_date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ]
  }



  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public adfFormService:ADFFormService
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.primaryForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10)])],
      mobile_phone: ['', Validators.compose([Validators.minLength(12), Validators.maxLength(12), Validators.required])],
      date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      reference_broker: ['', Validators.compose([Validators.required])],
      user_document_id: [''],
      uid: [''],
      title: ['', Validators.compose([Validators.maxLength(100),Validators.required])],
      addAnotherApplicantItem: this.formBuilder.array([]),
    });

    this.additionalForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10)])],
    })

  }
  ngOnInit() {
  }

  deleteSecondaryApplicant(index: number, document_id: any, uid: any, SDF_form_document_id: any) {
   debugger;
    let thiss = this;

    let alert = this.alertCtrl.create({
      title: 'Confirm delete Applicant',
      message: 'Are you sure you want to delete this Applicant?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {
                this.valueChange.emit(index);
                 let email = this.formApplicant.at(index).get('secondary_email').value;
                 if(email !== '') {
                    thiss.hidetoggle[index]=!thiss.hidetoggle[index];
                 }
                 //console.log(email);



                if(document_id =="" || document_id ==null || document_id ==undefined){
                  this.formApplicant.removeAt(index);


                }else{

                  let postData = {
                    'document_id' : document_id,
                    'SDF_form_document_id' : SDF_form_document_id,
                    'uid' : uid,
                    'deleted_date' : new Date().getTime()
                  }

                  this.formApplicant.removeAt(index);

                }

              }
          }
      ]
    });
    alert.present();
  }


  ngOnChanges() {

    this.primaryForm.controls.reference_broker.setValue(this.editdata.primary_applicant.primary_data.reference_broker);
    this.primaryForm.controls.firstname.setValue(this.editdata.primary_applicant.primary_data.firstname);
    this.primaryForm.controls.middlename.setValue(this.editdata.primary_applicant.primary_data.middlename);
    this.primaryForm.controls.lastname.setValue(this.editdata.primary_applicant.primary_data.lastname);
    this.primaryForm.controls.email.setValue(this.editdata.primary_applicant.primary_data.email);
    this.primaryForm.controls.mobile_phone.setValue(this.editdata.primary_applicant.primary_data.mobile_phone);
    this.primaryForm.controls.date_of_birth.setValue(this.editdata.primary_applicant.primary_data.date_of_birth);

  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  get formApplicant() {
    return this.primaryForm.get('addAnotherApplicantItem') as FormArray;
  }

  initaddAnotherApplicant() {
    return this.formBuilder.group({

      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  // initaddAnotherApplicant() {
  //   return this.formBuilder.group({


  //     secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],

  //   });
  // }

  initaddAnotherApplicant2(formObj,user_id) {
    return this.formBuilder.group({

      secondary_firstname: [formObj.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [formObj.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [formObj.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [formObj.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [formObj.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [formObj.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [user_id],
      document_id: ['']
    });
  }


  addAnotherApplicant() {

    debugger;

    this.formApplicant.push(this.initaddAnotherApplicant());

    this.indexx = this.formApplicant.length-1;

  }

  anotherApplicantUser(e,index){

    this.adfFormService.getApplicantDetailsByEmail(e.target.value)
    .then(data=>{
      const currentFormGroup2=this.primaryForm.controls['addAnotherApplicantItem']['controls'][index];


      currentFormGroup2.controls.secondary_firstname.setValue(data["user_data"].firstname);
      currentFormGroup2.controls.secondary_middlename.setValue(data["user_data"].middlename);
      currentFormGroup2.controls.secondary_lastname.setValue(data["user_data"].lastname);
      currentFormGroup2.controls.secondary_email.setValue(data["user_data"].email);
      currentFormGroup2.controls.secondary_mobile_phone.setValue(data["user_data"].mobile_phone);
      currentFormGroup2.controls.secondary_date_of_birth.setValue(data["user_data"].date_of_birth);

      this.anotherApplicant_evntemit.emit({userdata:data,index:index});
    }).catch(error=>{



    })
  }



  changeLog(event, index: any) {
    debugger;
    console.log(this.primaryForm);
    this.primaryformData_evntemit.emit(this.primaryForm);

  }
  onHandleAddi(event,index) {

    let user_email = event.value;

    let emailcheck= this.checkemailexists(user_email);
      if(!emailcheck) {
        return emailcheck;
      }
      //console.log('abdul');
    let thiss = this;

    if(user_email !== undefined) {

      //debugger;
      // let user_email = this.user_email;
      // console.log(user_email);
      this.loadingProvider.startLoading();
      this.adfFormService.getApplicantDetailsByEmail(user_email)
      .then((data:any)=>{

        let email = thiss.formApplicant.at(index).get('secondary_email').value;
        if(email !== '') {
          thiss.hidetoggle[index]=!thiss.hidetoggle[index];
       }
        //thiss.hidetoggle[index]=!thiss.hidetoggle[index];

        const currentFormGroup2=this.primaryForm.controls['addAnotherApplicantItem']['controls'][index];


        data.additional_index = index;
        currentFormGroup2.controls.secondary_firstname.setValue(data["user_data"].firstname);
        currentFormGroup2.controls.secondary_middlename.setValue(data["user_data"].middlename);
        currentFormGroup2.controls.secondary_lastname.setValue(data["user_data"].lastname);
        currentFormGroup2.controls.secondary_email.setValue(data["user_data"].email);
        currentFormGroup2.controls.secondary_mobile_phone.setValue(data["user_data"].mobile_phone);
        currentFormGroup2.controls.secondary_date_of_birth.setValue(data["user_data"].date_of_birth);

        console.log('additional' ,data.additional_index);
        //debugger;

        //this.sendEmployemntDetailsData.emit(data['contact_details'].employment_details);
        this.userdataAddi_evntemit.emit(data);
        this.loadingProvider.stopLoading();
        if(data) {
          this.presentToast('contact found.');
        }


      }).catch(error=>{

         let email = thiss.formApplicant.at(index).get('secondary_email').value;
          if(email !== '') {
             if(thiss.hidetoggle[index]) {

             }
             else {
              thiss.hidetoggle[index]=!thiss.hidetoggle[index];
             }

        }
        console.log(user_email);
        this.loadingProvider.stopLoading();
        this.presentToast('contact data is not exist.');
        // this.primaryForm.controls.firstname.setValue('');
        // this.primaryForm.controls.middlename.setValue('');
        // this.primaryForm.controls.lastname.setValue('');
        // this.primaryForm.controls.email.setValue(user_email);
        // this.primaryForm.controls.mobile_phone.setValue('');
        // this.primaryForm.controls.date_of_birth.setValue('');
        // this.primaryForm.controls.email.setValue('');
        let data = {
          status:'error',
          message:'not_found'
        }
        this.userdata_evntemit.emit(data);

      })

    }

  }

  checkemailexists(user_email) {
    let primary_email = this.primaryForm.get('email').value;
     if(primary_email == user_email) {
       this.presentToast('Email should be unique for additional applicant');
        return false;
     }
     else {

            console.log(this.primaryForm.value);
            let test = this.primaryForm.value.addAnotherApplicantItem.filter(data => data.secondary_email == user_email && user_email != null)
              console.log(test);
              if (test.length > 1) {
                  this.presentToast('Email should be unique for additional applicant');
                  return false;
                } else {
                  return true;
                }
          }


  }

  onHandleBlur(){

    //debugger;

    if(this.user_email !== undefined) {

      let user_email = this.user_email;
      console.log(this.user_email);
      this.loadingProvider.startLoading();
      this.adfFormService.getApplicantDetailsByEmail(this.user_email)
      .then((data:any)=>{

        console.log(data);

        debugger;

        this.sendEmployemntDetailsData.emit(data['contact_details'].employment_details);
        this.primaryForm.controls.firstname.setValue(data['user_data'].firstname);
        this.primaryForm.controls.middlename.setValue(data['user_data'].middlename);
        this.primaryForm.controls.lastname.setValue(data['user_data'].lastname);
        this.primaryForm.controls.email.setValue(data['user_data'].email);
        this.primaryForm.controls.mobile_phone.setValue(data['user_data'].mobile_phone);
        this.primaryForm.controls.date_of_birth.setValue(data['user_data'].date_of_birth);
        this.primaryForm.controls.reference_broker.setValue(data['user_data'].reference_broker);
        this.userdata_evntemit.emit(data);
        this.loadingProvider.stopLoading();
        if(data) {
          this.presentToast('contact found.');
        }


      }).catch(error=>{

        console.log(user_email);
        this.loadingProvider.stopLoading();
        this.presentToast('contact data is not exist.');
        // this.primaryForm.controls.firstname.setValue('');
        // this.primaryForm.controls.middlename.setValue('');
        // this.primaryForm.controls.lastname.setValue('');
        // this.primaryForm.controls.email.setValue(user_email);
        // this.primaryForm.controls.mobile_phone.setValue('');
        // this.primaryForm.controls.date_of_birth.setValue('');
        // this.primaryForm.controls.email.setValue('');
        let data = {
          status:'error',
          message:'not_found'
        }
        this.userdata_evntemit.emit(data);

      })

    }
  }
  collectLogData(event, type, index){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'address_type'){
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if(type == 'street_type'){
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if(type == 'state'){
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if(type == 'country'){
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if(type == 'housing_situation'){
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if(type == 'move_in_date'){
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if(type == 'date_of_birth'){
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }

  }

  changeLogData(event, type, index){
    debugger;
    if(event == undefined){
      return false;
    }
    this.new_val = event;
    this.old_val = '';
    var property = '';
    if(type == 'current_marital_status'){
      this.old_val = (this.applicant_details.current_marital_status == undefined) ? '' : this.applicant_details.current_marital_status;
      property = 'Current Marital Status';
    }
    if(type == 'gender'){
      this.old_val = (this.applicant_details.gender == undefined) ? '' : this.applicant_details.gender;
      property = 'Gender';
    }

    if(this.new_val != this.old_val){
      this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    }
  }

  public changeAddressFormat($event, index, types){
    let streetNumber = this.primaryForm.get('street_number');
    let streetName = this.primaryForm.get('street_name');
    let streetType = this.primaryForm.get('street_type');
    if(types == 'primary_address'){
      this.address_format = $event;
      streetNumber = this.primaryForm.get('street_number');
      streetName = this.primaryForm.get('street_name');
      streetType = this.primaryForm.get('street_type');
    }else if(types == 'primary_previous'){
      streetNumber = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
      streetName = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
      streetType = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    }else if(types == 'secondary_address'){
      streetNumber = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_number');
      streetName = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_name');
      streetType = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_type');
    }
    if($event == 'nonStandard'){
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }else if($event == 'poBox'){
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    }else{
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();

    this.new_val = event;
    this.old_val = '';
    var property = '';

  }

  phoneInput(event) {

    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  setFormatNumber(event, index) {
    var mobile_phone = '';
    if(index >= 0){
      mobile_phone = this.primaryForm.controls['addAnotherApplicantItem'].value[index].secondary_mobile_phone
      mobile_phone = mobile_phone.split(" ").join("");
      let firstFour = mobile_phone.slice(0, 4);
      let number = mobile_phone.slice(4, 10);
      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
      this.formApplicant.controls[index]['controls'].secondary_mobile_phone.setValue(number.trim());
    }else{
      mobile_phone = this.primaryForm.controls.mobile_phone.value;
      console.log(mobile_phone);
      if(mobile_phone !== null) {
        mobile_phone = mobile_phone.split(" ").join("");
        let firstFour = mobile_phone.slice(0, 4);
        let number = mobile_phone.slice(4, 10);
        number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
        this.primaryForm.controls.mobile_phone.setValue(number.trim());
      }

    }
  }
  onPaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.split(" ").join("");
    let firstFour = pastedText.slice(0, 4);
    let number = pastedText.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.primaryForm.controls.mobile_phone.setValue('');
    this.primaryForm.controls.mobile_phone.setValue(number.trim());
  }


  getValue() {

    this.valueChange.emit({primaryFormValue:this.primaryForm.value,primaryFormValid:this.primaryForm.valid,primaryForm:this.primaryForm});

  }

  populateDataForEdit(data,referenceBroker,fullData,modeOfOpeartion){
    debugger;
    this.modeOfOperation=modeOfOpeartion;
    this.alldataForEdit=fullData;

    let primary_user_data:any;

    let primary_user_id:any;
    let primary_additional_user_id:any;

    let additional_user_data:any=[];
    if(data.length > 0){
      for(var i=0;i<data.length;i++)
      {

        if(data[i].type == 'primary'){
          primary_user_data=data[i].user_data;
          primary_user_id=data[i].contact_details.uid;
        }
        else{
          additional_user_data.push(data[i].user_data);
          primary_additional_user_id=data[i].contact_details.uid;
        }
      }

      if(Object.keys(primary_user_data).length > 0)
      {


        this.primaryForm.get('reference_broker').setValue(referenceBroker);
        this.primaryForm.get('firstname').setValue(primary_user_data.firstname);
        this.primaryForm.get('middlename').setValue(primary_user_data.middlename);
        this.primaryForm.get('lastname').setValue(primary_user_data.lastname);
        this.primaryForm.get('email').setValue(primary_user_data.email);
        this.primaryForm.get('mobile_phone').setValue(primary_user_data.mobile_phone);
        this.primaryForm.get('date_of_birth').setValue(primary_user_data.date_of_birth);
        this.primaryForm.get('title').setValue(fullData[0].title);
        this.primaryForm.get('uid').setValue(primary_user_id);

      }
      if(additional_user_data.length > 0)
      {
        additional_user_data.forEach((element,index)=>{
          this.formApplicant.push(this.initaddAnotherApplicant2(element,primary_additional_user_id));
          this.hidetoggle[index]=!this.hidetoggle[index];
        });
      }
    }
    this.primaryformData_evntemit.emit(this.primaryForm);
  }

  getUserAndBrokerId(){

      if(this.modeOfOperation === 'yes')
      {
        this.UserAndBrokerId.emit({adf_form_id:this.alldataForEdit[0].adf_form_id,
          primary_contact_id:this.alldataForEdit[0].primary_contact_id,
          reference_broker:this.alldataForEdit[0].reference_broker});
      }
      else{
        this.UserAndBrokerId.emit({adf_form_id:"",
        primary_contact_id:"",
        reference_broker:""});
      }

  }
  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  getUserData(e) {

    this.primaryForm.controls.firstname.setValue(e.user_data.firstname);
    this.primaryForm.controls.middlename.setValue(e.user_data.middlename);
    this.primaryForm.controls.lastname.setValue(e.user_data.lastname);
    this.primaryForm.controls.email.setValue(e.user_data.email);
    this.primaryForm.controls.mobile_phone.setValue(e.user_data.mobile_phone);
    this.primaryForm.controls.date_of_birth.setValue(e.user_data.date_of_birth);
    this.primaryForm.controls.reference_broker.setValue(e.user_data.reference_broker);

  }

}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/primary-applicant/primary-form/primary.ts